// extracted by mini-css-extract-plugin
module.exports = {"form_container":"Login_form_container__1Obvm","login_page_container":"Login_login_page_container__107_N","language":"Login_language__1zD7G"};